export const InputErrorText = ({ text = "" }) => {
    return (
        <div>
            <span className="jlt-text-xs jlt-text-[#B42318]">{text}</span>
        </div>
    );
};
